import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setChangeUserPasswordFormAction } from "../../redux/rootReducer";
import { CHANGE_USER_PASSWORD_FORM_INITIAL } from "../../redux/initialStateConstant";
import { changeUserPasswordThunk } from "../../redux/thunks/changeUserPasswordThunk";

const ChangeUserPasswordForm = () => {
    const dispatch = useDispatch();
    const change_user_password_form = useSelector(state => state.change_user_password_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close"
                            onClick={ () => {
                                dispatch(setChangeUserPasswordFormAction(CHANGE_USER_PASSWORD_FORM_INITIAL));
                            } }
                        />
                        <div className="form__title">Смена пароля</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Новый пароль</div>
                        <input type="text" className="input"
                            value={ change_user_password_form.password }
                            onInput={ event => {
                                dispatch(setChangeUserPasswordFormAction({
                                    ...change_user_password_form,
                                    password: event.target.value
                                }));
                            } }
                        />
                    </div>

                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                dispatch(changeUserPasswordThunk({
                                    u_id: change_user_password_form.u_id,
                                    password: change_user_password_form.password
                                }));
                            } }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangeUserPasswordForm;